import {
  IDiscipline,
  IMainProcess,
  IMilestone,
  ISingleUser,
} from 'src/interface/org'
import BaseService from './BaseService'

export interface ValidateReq {
  discipline_ids: number[]
  user_ids: number[]
  mile_stone_ids?: number[]
  main_process_ids?: number[]
  project_id: number
  destination_project_id: number
}

export interface ValidateRes {
  disciplines?: Record<number, IDiscipline | null>
  users?: Record<number, ISingleUser | null>
  mile_stones?: Record<number, IMilestone | null>
  main_processes?: Record<number, IMainProcess | null>
}

export interface IOrgEntity {
  id: number
}

export interface CloneTimelineReq {
  disciplines?: Record<number, IOrgEntity | null>
  users?: Record<number, IOrgEntity | null>
  mile_stones?: Record<number, IOrgEntity | null>
  main_processes?: Record<number, IOrgEntity | null>
  destination_project_id: number | undefined
  source_project_id: number
  key_point_ids: number[]
  delivery_ids: number[]
  offset: number
}

export interface CloneTimelineRes {
  keypoints_created: number
  deliveries_created: number
}

class OrgSyncService extends BaseService {
  constructor() {
    super(true)
  }

  readonly validateMigration = async (
    data?: ValidateReq,
  ): Promise<ValidateRes> => {
    return this.post('miro/validate_project_migration', data)
  }

  readonly cloneTimeline = async (
    data: CloneTimelineReq,
  ): Promise<CloneTimelineRes> => {
    return this.post('miro/duplicate_miro_timeline', data)
  }
}

export default new OrgSyncService()
